import React, { useState } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

function OtpInput(props) {
     const { error } = props;

     const handleChange = (newValue) => {
          props.onChange(newValue);
          // setOtp(newValue);
     };
     return (
          <>
               <FormControl error={error}>
                    <MuiOtpInput
                         sx={{ gap: 1, mb: 2 }}
                         length={6}
                         value={props.otp}
                         onChange={handleChange}
                    />

                    {props.showValidation && (
                         <FormHelperText className="component-error-text">
                              {props.validationMsg}
                         </FormHelperText>
                    )}
               </FormControl>
          </>
     );
}

export default OtpInput;
